export interface TutorialStep {
  id: number
  text: string
}

export const TUTORIAL_YOUTUBE_EMBED_URL = 'https://www.youtube.com/embed/QqR9oY9SbxU'

export const TUTORIAL_STEPS: TutorialStep[] = [
  {
    id: 1,
    text: 'Seu contrato será registrado no sistema oficial do governo.',
  },
  {
    id: 2,
    text: 'Sua empresa receberá as informações do novo contrato para processar o desconto.',
  },
  {
    id: 3,
    text: 'Depois o desconto do novo contrato começará a aparecer na sua nova folha de pagamento.',
  },
  {
    id: 4,
    text: 'Por fim, seu contrato antigo será quitado e as novas parcelas entrarão em vigor.',
  },
]
